/**
 * Directional drift right gesture
 * @module gestures/effects/driftRight
 */
import { createDriftGesture } from './driftFactory.js';
export default createDriftGesture('right');
